<template>
  <form id="msisdn-form">
    <label class="landing-label">
      <span class="label-title">{{ $t('pages.login.labels.phone') }}</span>
      <input type="text"
             :placeholder="$t('pages.login.inputs.placeholders.phoneNumber')"
             v-model.trim="phoneNumber"
             :disabled="isLoading"
             @keydown.enter.prevent="handleSendSms"
             ref="phoneNumberInput"
      >
      <small v-if="user.validation_errors && user.validation_errors.phone">{{ user.validation_errors.phone[0] }}</small>
    </label>
    <small v-if="user.error && !(user.validation_errors && user.validation_errors.phone)">
        {{ user.error }}
    </small>
    <fieldset class="buttons">
      <button type="button"
              class="main-btn submit-btn phone-number"
              :disabled="isLoading"
              @click="handleSendSms"
      >
        <span class="spinner-label" v-if="!isLoading">{{ $t('pages.login.buttons.submit') }}</span>
        <span class="spinner-label" v-else>
          <span class="spinner-icon"></span>
          {{ $t('pages.login.buttons.sending') }}
        </span>
      </button>
    </fieldset>
  </form>
</template>

<script>
import MsisdnForm from './MsisdnForm';
export default MsisdnForm;
</script>

<style scoped>
/* Disabled button styling */
#msisdn-form .buttons .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: #999;
}

/* Disabled input styling */
#msisdn-form input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: #f5f5f5;
}

/* Spinner animation */
.spinner-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
